import { routeManifest } from "@/lib/navigation";
import { docsRoutes } from "@/lib/navigation-docs";
import { ESTATE_PATH, ESTATE_SETTINGS_PATH } from "@/lib/estates-ux";

/**
 * Every route that resolves to the AppShell component (`@/components/app-shell`).
 * Mirrors the Next.js App Router file tree, where each of these paths had a
 * `page.tsx` doing `export { default } from "@/pages/app-shell"` —
 * AppShell itself decides what to render internally via `useAppNavigation`
 * (currently Next-router-backed; see the migration report for follow-up).
 */
const additionalAppShellPaths = [
  "/",
  "/admin/maintenance-tasks",
  "/admin/scans",
  "/admin/task-executions",
  "/agents/agents-md-builder",
  "/agents/health",
  "/analytics/feedback-analysis",
  "/analytics/value-stream-waste",
  "/analytics/waste-index",
  "/analytics/waste-tracking",
  "/automations/campaigns/new",
  "/engineering-waste/map",
  "/engineering-waste/90-day-plan",
  "/estates/services",
  "/issue-intelligence",
  "/cli",
  "/docs",
  "/estate/:estateId/fleet/:fleetId/agents",
  "/estate/:estateId/fleet/:fleetId/inspections",
  "/estate/:estateId/fleet/:fleetId/repositories",
  "/estate/:estateId/fleet/:fleetId/repositories/add",
  "/estate/:estateId/fleet/:fleetId/repositories/upload",
  "/estate/:estateId/fleet/:fleetId/repositories/:repoId",
  "/estate/:estateId/fleet/:fleetId/repositories/:repoId/scans/:scanId",
  "/estate/:estateId/fleet/:fleetId/tasks/:taskId",
  ...docsRoutes.map(([slug]) => `/docs/${slug}`),
  ESTATE_PATH,
  ESTATE_SETTINGS_PATH,
  "/fleets",
  "/market-map",
  "/maintenance/find-new",
  "/maintenance/inspect",
  "/notifications",
  "/pages/dependency-tracker",
  "/pages/models",
  "/pages/preference-engine",
  "/pages/prompt-optimizations",
  "/repositories",

  "/repositories/overview",
  "/repositories/upload",
  "/repositories/:repoId",
  "/repositories/:repoId/scans/:scanId",
  "/services",
  "/settings/access",
  "/settings/account",
  "/settings/api-tokens",
  "/settings/estate-setup",
  "/settings/providers",
  "/settings/subscriptions",
  "/standards/suppressed-recommendations",
  "/tasks/:taskId",
] as const;

/**
 * The route manifest drives every static product/navigation destination. Keep
 * those paths in the router automatically so adding a navigation item cannot
 * create a link that falls through to the SPA 404 boundary.
 *
 * `additionalAppShellPaths` contains dynamic detail paths and compatibility
 * entries that cannot be represented by the static manifest.
 */
export const appShellPaths = Array.from(
  new Set([
    ...routeManifest.map((route) => route.path),
    ...additionalAppShellPaths,
  ]),
);
